import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid2,
  Stack,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
  Tooltip,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableComponent from "components/grid";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useEditKeyPMMutation } from "store/slices/apis/keyPMSlice";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import time from "assets/time.png";
import editLogo from "assets/EditIcon.svg";
import ClearIcon from "@mui/icons-material/ClearOutlined";
import { IoIosSearch } from "react-icons/io";
import { useGetAllMilestoneListQuery } from "store/slices/apis/milestonePackageSlice";
import { useEditKeyMilestoneMutation } from "store/slices/apis/keyMilestoneSlice";
import { usePermission } from "hooks/usePermission";
import { MILESTONE_VIEW } from "config";
import { ReactComponent as SearchIcon } from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import { ReactComponent as ClearNewIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const AllMilestone = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(1);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const mileStoneViewAccess = usePermission(MILESTONE_VIEW);
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
  });
  const { projectId } = useParams();
  const {
    data: allMilestone,
    refetch,
    isLoading,
  } = useGetAllMilestoneListQuery({
    ProjectId: projectId,
    sortBy: "createddate",
    sortOrder: "desc",
    from: filters?.fromDate,
    to: filters?.toDate,
    page: pageNumber,
    pageSize: 10,
    search: searchQuery,
  });

  const [data, setData] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [dialogRowId, setDialogRowId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [columns, setColumns] = useState([]);
  const [editKeyMilestone] = useEditKeyMilestoneMutation();

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    setPageNumber(1);
  }, [searchQuery]);

  const clearSearch = () => {
    setSearchQuery("");
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const cols = [
      {
        name: "Milestone ID",
        field: "milestone_number",
        renderer(params) {
          return (
            <Stack direction="row" spacing={1}>
              {params?.milestone_number && (
                <Chip
                  label={params?.milestone_number}
                  size="small"
                  sx={{
                    fontSize: "12px",
                    "& .MuiChip-label": {
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      fontWeight: 600,
                    },
                  }}
                />
              )}
            </Stack>
          );
        },
      },
      {
        name: "Milestone name",
        field: "milestone_name",
      },
      // {
      //   name: "Created Date",
      //   field: "createddate",
      //   renderer(params) {
      //     return (
      //       <>
      //         {params?.createddate
      //           ? moment(params.createddate).format("DD/MM/YY")
      //           : "N.A."}
      //       </>
      //     );
      //   },
      // },
      {
        name: "Plan Finish Date",
        field: "plan_date",
        renderer(params) {
          return (
            <>
              {params?.plan_date
                ? moment(params.plan_date).format("DD/MM/YY")
                : "N.A."}
            </>
          );
        },
      },
      {
        name: "Actual Finish Date",
        field: "actual_date",
        renderer: (row) => (
          <Box>
            <Grid2
              sx={{
                whiteSpace: "nowrap",
                color: "#474747",
                border: "none",
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "#F3F3F3",
                margin: "10px 20px 10px 0",
                border: "1px solid #D1D1D1 !important",
                borderRadius: "5px",
                maxWidth: "250px",
                padding: "10px !important",
                margin: "0 !important",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <div style={{ height: "16px", width: "16px" }}>
                  <img src={time} alt="" />
                </div>
                {row?.actual_date ? (
                  <span>{moment(row.actual_date).format("DD/MM/YY")}</span>
                ) : (
                  ""
                )}
              </div>
              <Tooltip title="Edit Actual Deployment Date">
                <div
                  style={{
                    height: "16px",
                    width: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleEditClick(row)}
                >
                  <img src={editLogo} alt="" />
                </div>
              </Tooltip>
            </Grid2>

            {selectedRowId === row?.id && (
              <div
                style={{
                  position: "absolute",
                  background: "#fff",
                  boxShadow: "0px 4px 6px rgba(0,0,0,0.3)",
                  zIndex: 10,
                  right: "50px",
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <StaticDatePicker
                    key={selectedRowId}
                    value={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                     slots={{
                      openPickerIcon: CustomCalendarIcon,   
                    }}
                    slotProps={{
                      actionBar: {
                        actions: [],
                      },
                    }}
                    sx={{
                      ".MuiPickersToolbar-root": {
                        display: "none",
                      },
                      ".MuiPickersLayout-root": {
                        marginLeft: "-125px",
                        marginTop: "-5px",
                        boxShadow: "0px 8px 16px -2px",
                      },
                      ".MuiPickersDay-root.Mui-selected": {
                        background: theme?.customSettings?.themeColor,
                      },
                      ".MuiPickersDay-root.Mui-selected:hover": {
                        background: theme?.customSettings?.themeColor,
                      },
                      ".MuiPickersDay-root:focus.Mui-selected": {
                        background: theme?.customSettings?.themeColor,
                      },
                      ".MuiDialogActions-root": {
                        display: "none",
                      },
                    }}
                  />
                </LocalizationProvider>
                <Grid2
                  sx={{
                    textAlign: "end",
                    marginRight: "20px",
                    marginBottom: "30px",
                  }}
                >
                  <Button
                    onClick={handleCloseCalendar}
                    variant="outlined"
                    sx={{
                      color: theme?.customSettings?.themeColor,
                      fontSize: "16px",
                      fontWeight: "500",
                      textTransform: "none",
                      border: `1px solid ${theme?.customSettings?.themeColor}`,
                      marginRight: "10px",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleDoneClick}
                    variant="contained"
                    sx={{
                      backgroundColor: theme?.customSettings?.themeColor,
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: "500",
                      textTransform: "none",
                    }}
                  >
                    Done
                  </Button>
                </Grid2>
              </div>
            )}

            <Dialog open={dialogRowId === row?.id} onClose={handleCloseDialog}>
              <DialogTitle
                sx={{
                  color: "#252525",
                  fontSize: "20px",
                  lineHeight: "24px",
                  fontWeight: 500,
                }}
              >
                Accept Changes
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                sx={(theme) => ({
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                })}
              >
                {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                <CrossIcon style={{ fontSize: "20px", width: "20px", height: "20px", fill: "#808080" }} />
              </IconButton>
              <DialogContent>
                <Typography
                  sx={{
                    color: "#474747",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: 400,
                  }}
                >
                  Are you sure you want to accept the changes? You can re edit
                  this later.
                </Typography>
              </DialogContent>
              <DialogActions
                sx={{
                  marginBottom: "20px",
                }}
              >
                <Button
                  onClick={handleCloseDialog}
                  variant="outlined"
                  sx={{
                    color: theme?.customSettings?.themeColor,
                    fontSize: "16px",
                    fontWeight: "500",
                    textTransform: "none",
                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={confirmChange}
                  variant="contained"
                  sx={{
                    backgroundColor: theme?.customSettings?.themeColor,
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "500",
                    textTransform: "none",
                    marginRight: "20px",
                  }}
                >
                  Accept Changes
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        ),
      },
      {
        name: "Action",
        field: "action",
        option: {},
      },
    ];

    setColumns(cols);
  }, [selectedRowId, selectedDate, dialogRowId]);

  useEffect(() => {
    if (allMilestone?.data) {
      const tempData = allMilestone?.data.map((item) => ({ ...item }));
      if (searchQuery) {
        const filteredData = tempData?.filter(
          (item) =>
            item?.milestone_number
              ?.toLowerCase()
              .includes(searchQuery.toLowerCase()) ||
            item?.milestone_name
              ?.toLowerCase()
              .includes(searchQuery.toLowerCase())
        );
        setData(filteredData);
      } else {
        setData(tempData);
      }
    }
  }, [allMilestone?.data, searchQuery]);

  const handleEditClick = (row) => {
    setSelectedRowId(row?.id);
    setSelectedRowData(row);
    setSelectedDate(row?.actual_date ? dayjs(row.actual_date) : dayjs());
  };

  const handleCloseCalendar = () => {
    setSelectedRowId(null);
    setSelectedDate(null);
  };

  const handleDoneClick = () => {
    setDialogRowId(selectedRowId);
  };

  const handleCloseDialog = () => {
    setDialogRowId(null);
  };

  const confirmChange = async () => {
    const updatedDate =
      dayjs(selectedDate).format("YYYY-MM-DD") + "T00:00:00.000Z";

    const updatedRow = { ...selectedRowData, actual_date: updatedDate };

    let reqBody = {
      consultant_contractor: updatedRow?.consultant_contractor,
      plan_date: updatedRow.plan_date,
      quantity: updatedRow.quantity,
      actual_date: updatedRow?.actual_date,
      owned: updatedRow.owned,
      milestone_name: updatedRow.milestone_name,
      comment: updatedRow.comment,
      ProjectId: updatedRow?.projectId,
      id: updatedRow?.id,
      milestone_number: updatedRow?.milestone_number,
      project: updatedRow?.project,
      version: updatedRow?.version,
      status: updatedRow?.status,
      approved_status: updatedRow?.approved_status,
      active: updatedRow?.active,
      date: updatedRow?.date,
      pm_reporting_date: updatedRow?.pm_reporting_date,
      updatedate: updatedRow?.updatedate,
      createddate: updatedRow?.createddate,
      createdby: updatedRow?.createdby,
      updatedby: updatedRow?.updatedby,
      workflowApprovalId: updatedRow?.workflowApprovalId
    };

    try {
      const formData = new FormData();
      formData.append("milestoneJson", JSON.stringify({ ...reqBody }));
      const response = await editKeyMilestone({
        id: updatedRow?.id,
        body: formData,
      }).unwrap();
      if (response?.status == "Success") {
        openNotification(response?.message, "success");
        setDialogRowId(null);
        setSelectedRowId(null);
        setSelectedDate(null);
        refetch();
      } else {
        openNotification("Error in p-and-m updation");
      }
    } catch (error) {
      console.log("errr", error);
      openNotification(error?.data?.message, "error");
      setDialogRowId(null);
      setSelectedRowId(null);
      setSelectedDate(null);
    }
  };

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: {
          color: type,
        },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

  const CustomCalendarIcon = (props) => (
  <CalendarIcon {...props} style={{ width: 26, height: 26, fill:"#696969 ", stroke:"#696969", strokeWidth:4 }} />
);

  const handleActionView = (row) => {
    const encrypted = encrypt("view");
    navigate(`/projects/${projectId}/milestone-detail/${row?.id}/${encrypted}/false`);
  }
  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: "20px" }}>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: 'start', sm: 'center' },
              justifyContent: "space-between",
              flexDirection: { xs: 'column', sm: 'row' }
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{
                // flexGrow: 2,
                alignItems: { xs: "stretch", sm: "center" },
                width: { xs: '100%', sm: 'auto' },
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="From Date"
                    value={fromDate}
                    format="DD-MM-YYYY"
                    onChange={(newValue) => setFromDate(newValue)}
                    slots={{
                      openPickerIcon: CustomCalendarIcon,   
                    }}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: "",
                            toDate: toDate
                              ? dayjs(toDate).format("YYYY-MM-DD")
                              : "",
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="To Date"
                    value={toDate}
                    format="DD-MM-YYYY"
                    clearable={true}
                    onChange={(newValue) => setToDate(newValue)}
                     slots={{
                      openPickerIcon: CustomCalendarIcon,   
                    }}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: fromDate
                              ? dayjs(fromDate).format("YYYY-MM-DD")
                              : "",
                            toDate: "",
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <Button
                loading={isLoading}
                onClick={() => {
                  setFilters({
                    fromDate: fromDate
                      ? dayjs(fromDate).format("YYYY-MM-DD")
                      : "",
                    toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
                  });
                }}
                size="large"
                // startIcon={<IoMdSearch />}
                startIcon={<SearchIcon style={{ height: "20px", width: "20px", fill: `${theme?.customSettings?.themeColor}` }} />}
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 20px",
                  marginTop: "12px !important",
                }}
              >
                Search
              </Button>
              <Button
                loading={isLoading}
                onClick={() => {
                  setFromDate(null);
                  setToDate(null);
                  const clearedValues = Object.fromEntries(
                    Object.keys(filters).map((key) => [key, ""])
                  );
                  setFilters(clearedValues);
                }}
                size="large"
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 15px",
                  marginTop: "12px !important",
                }}
              >
                Reset
              </Button>
            </Stack>
          </Box>
        </Grid2>

        <Grid2
          sx={{
            width: {
              xs: '100%',
              sm: '500px',
              md: '500px',
              lg: '500px'
            }
          }}
        >
          <TextField
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search by Milestone Name, Milestone ID"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {/* <IoIosSearch /> */}
                  <SearchIcon style={{ width: "16px", height: "16px", fill: "#252525" }} />
                </InputAdornment>
              ),
              style: {
                fontSize: "16px",
              },
              endAdornment: searchQuery?.length > 0 && (
                <IconButton onClick={clearSearch} edge="end">
                  {/* <ClearIcon style={{ fontSize: "16px" }} /> */}
                  <ClearNewIcon style={{ fontSize: "16px", width: "16px", height: "16px" }} />
                </IconButton>
              ),
            }}
            fullWidth
            sx={{
              height: "48px",
              background: "#fff",
              "& .MuiInputBase-root": {
                height: "48px",
              },
              "& .MuiInputBase-input": {
                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: "400",
                color: "#696969",
                opacity: 1,
              },
              "& .MuiInputBase-input::placeholder": {
                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: "400",
                color: "#696969",
                opacity: 1,
              },
            }}
          />
        </Grid2>


        <Grid2 size={12} sx={{ mt: 2 }}>
          <TableComponent
            columns={columns
              .map((col) =>
                col.field === "action"
                  ? {
                    ...col,
                    option: {
                      ...col.option,
                      view: mileStoneViewAccess,
                    },
                  }
                  : col
              )
              .filter((col) => {
                if (col.field !== "action") {
                  return true;
                } else {
                  return Object.values(col.option).some((v) => v === true);
                }

              })}
            data={data}
            isLoading={isLoading}
            actionView={handleActionView}
          />
          {!isLoading && (
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <PaginationComponent
                pageNumber={allMilestone?.pagination?.currentPage || 1}
                totalPages={allMilestone?.pagination?.totalPages || 1}
                onPageChange={setPageNumber}
              />
            </Box>
          )}
        </Grid2>
      </Grid2>
    </>
  );
};

export default AllMilestone;
